import testServer from '@/api/management.js'
import moment from 'moment'

const mount  =  (params) =>{
  return  moment(params).format('YYYY-MM-DD')
}
const chageWord = (params) =>{
    
    switch (params) {
        case 0:
    return '一星级'
        case 1:
    return'一星级'
        case 2:
    return '二星级'
        case 3:
    return '三星级' 
        case 4:
    return '四星级'
        case 5:
    return '五星级'
        case 6:
    return '六星级'
        case 7:
    return '七星级'
        case 8:
    return '八星级'
        case 9:
    return '九星级'
        case 10:
    return '十星级'        
    }
}
const Status = (params) =>{
    if(params ===0 ) {return '已发布'}
        else {  return '下架'}
}
const imgName = (params) =>{
    let index = params.lastIndexOf('/')
    
    params = params.substring(index + 1, params.length)
    return params
}
const naimeng =(params) =>{
    let index = params.indexOf(',')
    console.log(index)
    console.log(params)
    if (index === -1) {
        return params
    } else{
        return params = params.substring(0,index)
    }
    
}
const wordarr = (params) =>{
  return  params.split(',');
}
const domain = (params) =>{
    let arr = []
    for (let index = 0; index < params.length; index++) {
        arr.push({
            value:params[index],
          
        })
    }
    return arr
}
const findClass = (params,arr) =>{
    for(let index =0; index<arr.length;index++){
        if(arr[index].name ===params){
            return arr[index].id
        }
    }
}

const  state={
    wordList:{},
    tablist:[],
    sClass:[],
    total:'',
    page:'',
    find:{}

    }
const   mutations={
        page(state,labelList){
            state.page = labelList
        },
        find(state,labelList){
            state.find = labelList
        },
        word_List(state,labelList){
          state.wordList = labelList.content.map((item,index) => ({
             
              '词语名称':naimeng(item.name),
              '词语展示':item.name,
              '拼音':item.spell,
              '上传时间':mount(item.updateTime),
              '星级':item.star,
              '文件':[{name:item.audio}],
               id:item.id,
              '页面':'词库查看'
          }))
          state.tablist =[
        
            { prop: '词语名称', label: '词语名称' },
            { prop: '拼音', label: '拼音' },
            { prop: '上传时间', label: '上传时间' },
            { slot: 'opt',label: '操作' }
          ]
         
          state.total = labelList.total
        },

        word_Checkpoint(state,labelList){

            state.wordList = labelList.content.map((item,index) => ({
             
                '日期': mount(item.updateTime),
                '关卡名称': item.name,
                '星级': item.star,
                '展示用':item.star+'星',
                '词语数': item.words,
                '页面':'词库管理',
                id:item.id

            }))
            state.tablist =[
          
         
            { prop: '关卡名称', label: '关卡名称' },
            { prop: '展示用', label: '星级' },
            { prop: '词语数', label: '词语数'},
            { prop: '日期', label: '上传时间' },
            { slot: 'opt',label: '操作' }
            ]
            state.total = labelList.total
        },
        article_star(state,labelList){
            state.wordList = labelList.content.map((item,index) => ({
                '序号': index+1,
                '文章星级': item.star,
                '展示星级': chageWord(item.star),
                '文章数': item.articles,
                '上传时间': mount(item.updateTime),
            }))
            state.tablist = [
            
            { prop: '文章星级', label: '文章星级' },
            { prop: '文章数', label: '文章数' },
            { prop: '上传时间', label: '上传时间' },
            { slot: 'opt',label: '操作'  }
           ]
           state.total = labelList.total
        },
        article_list(state,labelList){
            state.wordList =labelList.content.map((item,index) => ({
              
                '文章序号':item.serialNumber,
                '文章名称':item.name,
                '上传时间':mount(item.updateTime),
                '核心词':item.coreWords,
                '句子':domain(item.sentenceList),
                '作者':item.author,
                '文件':item.audio,
                '页码':item.pageNumber,
                 id:item.id
                     }))
            state.tablist = [
           
            { prop: '文章序号', label: '文章序号' },
            { prop: '文章名称', label: '文章名称' },
            { prop: '上传时间', label: '上传时间' },
            { slot: 'opt',label: '操作'  }]
            state.total = labelList.total
        },
        startup_Page(state,labelList){
            state.wordList = labelList.content.map((item,index) => ({
               
                '图片名称': imgName(item.img),
                '图片预览': item.img,
                '上传时间': mount(item.updateTime),
                '状态': Status(item.status),
                link:item.link,
                id:item.id
            }))
            state.tablist = [  
           
            { prop: '图片名称', label: '图片名称' },
            { prop: '图片预览', label: '图片预览' },
            { prop: '状态', label: '状态' },
            { slot: 'opt',label: '操作'  }
           ]
           state.total = labelList.total
         
        },
        composition_list(state,labelList){
            testServer.classNmae.class({asas:1}).then(res =>{
                // eslint-disable-next-line no-console
               state.sClass = res.data.data
            })
            state.wordList = labelList.content.map((item,index) =>({
                
                '作文题目':item.title,
                '老师':item.teacherName,
                '下发班级':item.className,
                '发布时间':mount(item.updateTime),
                '发布状态':Status(item.status),
                '详情':item.description,
                id:item.id,
                classId:findClass(item.className,state.sClass)

            }))
            state.tablist = [ 
            { prop: '作文题目', label: '作文题目' },
            { prop: '老师', label: '老师' },
            { prop:'下发班级', label:'下发班级'},
            { prop:'发布状态',label:'发布状态'},
            { prop:'发布时间',label:'发布时间'},
            { slot: 'opt',label: '操作'  }
           ]
           state.total = labelList.total
          
        },
        awesomeComposition_list(state,labelList){
            testServer.classNmae.class({asas:1}).then(res =>{
                // eslint-disable-next-line no-console
               state.sClass = res.data.data
            })
            state.wordList = labelList.content.map((item,index) =>({
              
                '作文题目':item.title,
                '姓名':item.name,
                '下发班级':item.className,
                '发布时间':mount(item.updateTime),
                '状态':Status(item.status),
                classId:findClass(item.className,state.sClass),
                img:item.img,
                id:item.id,    
            }))
            state.tablist = [  
            { prop: '作文题目', label: '作文题目' },
            { prop: '姓名', label: '姓名' },
            { prop:'下发班级', label:'下发班级'},
            { prop:'状态',label:'状态'},
            { prop:'发布时间',label:'发布时间'},
            { slot: 'opt',label: '操作'  }
           ]
           state.total = labelList.total
        }

    }
const  actions={
        'FETCH_CHECKPOINT_LIST':  async ({
            // eslint-disable-next-line no-unused-vars
            commit
        },page) =>{
            let prams = {
                page:1,
                pageSize:20,
              
            }
         
            if (page) {
              prams.page =page.page  
              prams.name = page.name
              if (page.pageSize) {
                prams.pageSize = page.pageSize  
              }
              if (page.data) {
                prams.beginTime = page.data[0]
                prams.endTime = page.data[1] 
              }
            }
         
              
              
              
              
            
            const res = await testServer.word.checkpoint(prams)
            // eslint-disable-next-line no-console
            const    wordData =   res.data.data
            commit('word_Checkpoint', wordData)
            commit('page', res.data.page)
        },
        'FETCH_WORD_LIST': async({
            commit,
          
        },id) =>{
            console.log('sadsadsadasdasdas',id.page)
            let prams = {
                checkpointId:id.id,
               
                keyword:id.name,
               
            }
          
            if (id) {
                console.log('sadsadsadasdasdas',id.page)
                prams.page = id.page
                if (id.pageSize) {
                    prams.pageSize = id.pageSize  
                  }
                if (id.data) {
                    prams.beginTime=id.data[0],
                    prams.endTime=id.data[1]
                }
            }

            const res = await testServer.word.list(prams)
            // eslint-disable-next-line no-console
            console.log(res)
            commit('word_List', res.data.data)
            commit('page', res.data.page)
        },
        
        'FETCH_WORD_SAVE': async({
            commit
        },id) =>{
            const res  = await testServer.word.save(id)
            // eslint-disable-next-line no-console
            console.log(res)

        },
        'FETCH_ARTICLE_STAR': async({
            commit
        },page) =>{
            let prams = {
                page:1,
                pageSize:20
            }
            if(page === undefined){
               
            } else{
                prams.page =page.page
                if (page.pageSize) {
                    prams.pageSize = page.pageSize  
                  }
                if (page.data === null) {
                    prams.star = page.name
                } else {
                    prams.star = page.name
                    prams.beginTime = page.data[0]
                    prams.endTime = page.data[1]
                }
              
              
            }
            const res = await testServer.article.star(prams)
              // eslint-disable-next-line no-console
              console.log('dadas',res)
              commit('article_star',res.data.data)
              commit('page', res.data.page)
        },
        'FETCH_ARTICLE_LIST': async({
            commit
        },page) =>{
            let params = {
                star:page.star,
               
                page:1,
                pageSize:20
            }
         
            if (page.data) {
                params.beginTime=page.data[0]
                params.endTime =page.data[1]
            }
            if (page.pageSize) {
                params.pageSize = page.pageSize  
              }

            if ( page.keyword) {
                 params.keyword=page.keyword
            } 
           
            if (page.page) {
                params.page = page.page
            }
            
            const res = await testServer.article.list(params)
            console.log('文章列表',res)
            commit('article_list',res.data.data)
            commit('page', res.data.page)
        },
        'FETCH_STARTUPPAGE_LIST':async({
            commit
        },page) =>{
            let params ={
                page:1,
                pageSize:20
            }
           
            if (page) {
                params.page = page.page
            }
            if (page.pageSize) {
                params.pageSize = page.pageSize
            }
            const res = await testServer.startupPage.list(params)
            // eslint-disable-next-line no-console
            console.log('dadas',res)
            commit('startup_Page',res.data.data)
            commit('page', res.data.page)
        },
        'FETCH_COMPOSITION_LIST':async({
            commit
        },page) =>{
            let prams = {
                page:1,
                pageSize:20,
                sort:'updateTime,desc'
            }
            if (page) {
                prams.page =page.page
                if (page.pageSize) {
                    prams.pageSize = page.pageSize  
                  }
    
                if (page.data) {
                 
                    prams.keyword = page.name
                    prams.status = page.status
                    prams.beginTime = page.data[0]
                    prams.endTime = page.data[1]
                }else{
                    prams.keyword =page.name
                    prams.status =page.status 
                }
            }
            
            // if(page === undefined){

            // } else{
               
            //     if (page.data === null) {
            //         prams.keyword =page.name
            //         prams.status =page.status
                  
            //     } else if( page.data[0]) {
            //     prams.keyword = page.name
            //     prams.status = page.status
            //     prams.beginTime = page.data[0]
            //     prams.endTime = page.data[1]
            // }
            // }
            const res = await testServer.composition.list(prams)
            // eslint-disable-next-line no-console
            console.log('作文',res.data.data.content)
            commit('composition_list',res.data.data)
            commit('page', res.data.page)
        },
        'FETCH_AWESOMECOMPOSITION_LIST':async({
            commit
        },page) =>{
            let prams = {
                page:1,
                pageSize:20,
                sort:'updateTime,desc'
            }
            if(page === undefined){

            } else{
                if (page) {
                    prams.page = page.page
                    if (page.pageSize) {
                        prams.pageSize = page.pageSize  
                      }
        
                    if (page.data) {
                        prams.keyword = page.name
                        prams.status = page.status
                        prams.beginTime = page.data[0]
                        prams.endTime = page.data[1]
                     
                    } else {
                        prams.keyword =page.name
                        prams.status =page.status
                  
                }
                }
               
        }
            const res = await testServer.awesomeComposition.list(prams)
            // eslint-disable-next-line no-console
            console.log('优秀作文',res.data.data.content)
            commit('awesomeComposition_list',res.data.data)
            commit('page', res.data.page)
        }

    }

    export default {
        namespaced: true,
        state,
        mutations,
        actions
      }
